/**
 * Token de API Frappe (api_key:api_secret) usado na autenticação por header
 * `Authorization: token <api_key>:<api_secret>`.
 *
 * Módulo neutro, sem dependências, para evitar import circular — é consumido
 * por httpClient, axiosClients, utils/axios, authHttp, config, authStore e
 * pelos uploads via fetch. Espelha o padrão de CRM/SAG-GRV (src/utils/http.ts).
 */
const TOKEN_KEY = "max_monitor_token";

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}
